import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import TripDetails from './TripDetails';
import ActionBlock from './ActionBlock';
import SendMessage from './SendMessage';
import ThreadItems from './ThreadItems';
import ClaimDetails from './TripDetails/ClaimDetails';
import Loader from '../Loader';
import ReportUserModal from '../ReportUserModal/ReportUserModal';
import ThankYouModal from '../ThankYouModal/ThankYouModal';

import GetThreadQuery from './GetThreadQuery.graphql';
import GetMoreThreadItemsQuery from './GetMoreThreadItemsQuery.graphql';
import messages from '../../locale/jsonMessages';

import { withQuery } from '../../hoc/withGraphql';

import cs from '../../components/commonStyle.css';
import s from './ViewMessage.css';

const ViewMessage = (props) => {
  const { threadItemsData: { loading, getThread, refetch, fetchMore } } = props;
  const threadItems = getThread && getThread?.threadItems;
  const { threadId, userType } = props;
  const getInquiry = getThread && getThread?.getInquiry;

  const [showModal, setShowModal] = useState(false);

  const isAdminAuthenticated = useSelector(state => state.runtime.isAdminAuthenticated);
  const currencyRates = useSelector(state => state.currency);

  const loadMore = () => {
    fetchMore({
      query: GetMoreThreadItemsQuery,
      variables: {
        threadId,
        offset: threadItems?.length,
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        if (!fetchMoreResult) { return previousResult; }
        return {
          getThread: {
            ...previousResult.getThread,
            threadItems: [...previousResult.getThread.threadItems, ...fetchMoreResult.getAllThreadItems],
          },
        };
      },
    });
  }
  const changeModalState = (status = false) => setShowModal(status);

  const openModal = () => changeModalState(true);
  if (loading) {
    return <Loader type={'text'} />;
  }
  if (getThread && getThread.threadItemForType && getThread.hostProfile && getThread.guestProfile) {
    let receiverName = getThread.guestProfile.firstName,
      hostUserBanStatus = getThread.hostUserData && getThread.hostUserData.userBanStatus,
      guestUserBanStatus = getThread.guestUserData && getThread.guestUserData.userBanStatus,
      senderName = getThread.hostProfile.firstName,
      receiverType = 'renter', isListAvailable = false,
      receiverEmail = getThread.guestUserData && getThread.guestUserData.email;
    if (userType === "renter") {
      receiverName = getThread.hostProfile.firstName;
      senderName = getThread.guestProfile.firstName;
      receiverType = 'owner';
      receiverEmail = getThread.hostUserData && getThread.hostUserData.email;
    }
    let listPublishStatus;
    const initialValues = {
      threadId,
      threadType: userType,
      type: 'message',
      receiverName,
      senderName,
      receiverType,
      receiverEmail
    };

    if (getThread && getThread.listData) {
      isListAvailable = true
    }

    if (getThread && getThread.listData) {
      listPublishStatus = getThread.listData.isPublished
    }

    return (
      <div>
        {!loading && <ReportUserModal profileId={userType === 'owner' ? getThread?.guestProfile?.profileId : getThread?.hostProfile?.profileId} />}
        <ThankYouModal />
        <Row>
          {/* web view message */}
          <Col lg={7} md={7} sm={6} xs={12} className={cx(s.space4)}>
            <div className={cx(s.viewMessageContainer, s.viewMessageContainerWeb)}>
              {
                !isAdminAuthenticated && <SendMessage
                  initialValues={initialValues}
                  threadId={threadId}
                  profileId={userType === 'owner' ? getThread.hostProfile.profileId : getThread.guestProfile.profileId}
                  picture={userType === 'owner' ? getThread.hostProfile.picture : getThread.guestProfile.picture}
                  displayName={userType === 'owner' ? getThread.hostProfile.firstName : getThread.guestProfile.firstName}
                />
              }
              <ThreadItems
                userType={userType}
                threadId={threadId}
                data={getThread}
                loadMore={loadMore}
              />
            </div>
          </Col>

          <Col lg={5} md={5} sm={6} xs={12} >
            {
              !isAdminAuthenticated && !guestUserBanStatus && !hostUserBanStatus &&
              <ActionBlock
                threadType={userType}
                actionType={getThread.threadItemForType.type}
                threadId={threadId}
                listId={getThread.listId}
                reservationId={getThread.threadItemForType.reservationId}
                startDate={getThread.threadItemForType.startDate}
                endDate={getThread.threadItemForType.endDate}
                personCapacity={getThread.threadItemForType.personCapacity}
                createdAt={getThread.threadItemForType.createdAt}
                hostDisplayName={getThread.hostProfile.firstName}
                guestDisplayName={getThread.guestProfile.firstName}
                guestEmail={getThread.guestUserData && getThread.guestUserData.email}
                title={getThread.listData && getThread.listData.title}
                listPublishStatus={listPublishStatus}
                startTime={getThread.threadItemForType.startTime}
                endTime={getThread.threadItemForType.endTime}
                getInquiry={getInquiry}
              />
            }

            {/* Mobile view message */}
            <div className={cx(s.viewMessageContainer, s.space4, s.viewMessageContainerMobile)}>
              {
                !isAdminAuthenticated && <SendMessage
                  initialValues={initialValues}
                  threadId={threadId}
                  profileId={userType === 'owner' ? getThread.hostProfile.profileId : getThread.guestProfile.profileId}
                  picture={userType === 'owner' ? getThread.hostProfile.picture : getThread.guestProfile.picture}
                  displayName={userType === 'owner' ? getThread.hostProfile.firstName : getThread.guestProfile.firstName}
                />
              }
              <ThreadItems
                userType={userType}
                threadId={threadId}
                data={getThread}
                loadMore={loadMore}
              />
            </div>


            <div className={cx(s.detailsContainer)}>
              {
                isListAvailable && <TripDetails
                  listId={getThread.listId}
                  userType={userType}
                  title={getThread?.threadItemForType?.reservation?.listTitle ? getThread.threadItemForType.reservation.listTitle : getThread?.listData?.title}
                  basePrice={getThread && getThread.threadItemForType && getThread.threadItemForType.reservation ? getThread.threadItemForType.reservation.basePrice : getThread.listData.listingData.basePrice}
                  delivery={getThread && getThread.threadItemForType && getThread.threadItemForType.reservation ? getThread.threadItemForType.reservation.delivery : getThread.listData.listingData.delivery}
                  monthlyDiscount={getThread.listData && getThread.listData.listingData && getThread.listData.listingData.monthlyDiscount}
                  weeklyDiscount={getThread.listData && getThread.listData.listingData && getThread.listData.listingData.weeklyDiscount}
                  currency={getThread && getThread.threadItemForType && getThread.threadItemForType.reservation ? getThread.threadItemForType.reservation.currency : getThread.listData.listingData.currency}
                  startDate={getThread.threadItemForType.startDate}
                  endDate={getThread.threadItemForType.endDate}
                  personCapacity={getThread.threadItemForType.personCapacity}
                  cancelData={getThread.threadItemForType.cancelData}
                  reservationData={getThread.threadItemForType.reservation || undefined}
                  startTime={getThread.threadItemForType.startTime}
                  endTime={getThread.threadItemForType.endTime}
                  currencyRates={currencyRates}
                  refetchData={refetch}
                  showModal={showModal}
                  changeModalState={changeModalState}
                  openModal={openModal}
                  profileId={userType === 'owner' ? getThread.guestProfile.profileId : getThread.hostProfile.profileId}
                  picture={userType === 'owner' ? getThread.guestProfile.picture : getThread.hostProfile.picture}
                  displayName={userType === 'owner' ? getThread.guestProfile.firstName : getThread.hostProfile.firstName}
                  location={userType === 'owner' ? getThread.guestProfile.location : getThread.hostProfile.location}
                  reviewsCount={userType === 'owner' ? getThread.guestProfile.reviewsCount : getThread.hostProfile.reviewsCount}
                  verifications={userType === 'owner' ? getThread.guestProfile.userVerification : getThread.hostProfile.userVerification}
                  getInquiry={getInquiry}
                />
              }
              {!isListAvailable && <FormattedMessage {...messages.noList} />}
            </div>
            {
              userType == 'renter' && getThread.threadItemForType.reservation && (getThread.threadItemForType.reservation.claimStatus === 'fullyRefunded' || getThread.threadItemForType.reservation.claimStatus === 'approved') &&
              <div className={cx(s.detailsContainer, s.space4, s.spaceTop4)}>
                <ClaimDetails reservationData={getThread.threadItemForType.reservation} openModal={openModal} />
              </div>
            }
          </Col>
        </Row>
      </div>
    );
  }
  return (
    <Grid fluid>
      <Row>
        <Col lg={12} md={12} sm={12} xs={12} className={s.space4}>
          <p className={cx(cs.fontWeightBold, cs.commonMediumText, cs.textAlignCenter)}>
            <FormattedMessage {...messages.noThreadFound} />
          </p>
        </Col>
      </Row>
    </Grid>
  );
}

ViewMessage.propTypes = {
  formatMessage: PropTypes.any,
  threadId: PropTypes.number.isRequired,
  userType: PropTypes.string.isRequired,
  threadItemsData: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    getThread: PropTypes.shape({
      guestProfile: PropTypes.shape({
        profileId: PropTypes.number.isRequired,
        picture: PropTypes.string,
        displayName: PropTypes.string.isRequired,
        firstName: PropTypes.string.isRequired,
        location: PropTypes.string,
        reviewsCount: PropTypes.number,
        userVerification: PropTypes.object,
      }),
      guestUserData: PropTypes.shape({
        email: PropTypes.string.isRequired,
        userBanStatus: PropTypes.number,
      }),
      hostProfile: PropTypes.shape({
        profileId: PropTypes.number.isRequired,
        picture: PropTypes.string,
        displayName: PropTypes.string.isRequired,
        firstName: PropTypes.string.isRequired,
        location: PropTypes.string,
        reviewsCount: PropTypes.number,
        userVerification: PropTypes.object,
      }),
      hostUserData: PropTypes.shape({
        email: PropTypes.string.isRequired,
        userBanStatus: PropTypes.number,
      }),
      threadItemForType: PropTypes.shape({
        reservationId: PropTypes.number,
        startDate: PropTypes.string.isRequired,
        endDate: PropTypes.string.isRequired,
        personCapacity: PropTypes.number.isRequired,
        createdAt: PropTypes.string.isRequired,
        cancelData: PropTypes.shape({
          guestServiceFee: PropTypes.number,
          hostServiceFee: PropTypes.number,
          refundToGuest: PropTypes.number,
          payoutToHost: PropTypes.number,
          total: PropTypes.number,
          currency: PropTypes.string,
        })
      }),
      listData: PropTypes.shape({
        title: PropTypes.string.isRequired,
        listingData: PropTypes.shape({
          basePrice: PropTypes.number.isRequired,
          delivery: PropTypes.number.isRequired,
          currency: PropTypes.string.isRequired,
        }),
      }),
    }),
  }),
};
ViewMessage.defaultProps = {
  threadId: null,
};

export default compose(
  withStyles(cs, s),
  withQuery(GetThreadQuery, {
    name: 'threadItemsData',
    options: props => ({
      variables: {
        threadId: props.threadId,
        threadType: props.userType,
      },
      ssr: false,
      fetchPolicy: 'network-only',
    }),
  }),
)(ViewMessage);
